module.exports = __webpack_public_path__ + "static/media/bookinfo.15d5a219.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/bookinfo.svg
// module id = 607
// module chunks = 0